import { FileText } from 'lucide-react'
import { SearchSecuritiesReportChunkResult } from 'poc-ai-biz-irdb_domain-model'

export type SourceDocumentSearchSecuritiesReportChunkCardProps = {
  securitiesReportChunk: SearchSecuritiesReportChunkResult['securitiesReportChunks'][0]
  query: string
}

export const SourceDocumentSearchSecuritiesReportChunkCard: React.FC<SourceDocumentSearchSecuritiesReportChunkCardProps> = ({
  securitiesReportChunk,
  query,
}) => {
  const { title, filerName, fiscalPeriodEndYear, docDescription, trimmedChunkContent } = securitiesReportChunk
  const subInfo = [filerName, fiscalPeriodEndYear ? `${fiscalPeriodEndYear}年` : null, docDescription].filter(Boolean).join(' | ')

  return (
    <div className="block p-3 border border-gray-200 rounded-md bg-white">
      <div className="flex items-start gap-2">
        <FileText className="h-4 w-4 text-blue-600 mt-0.5 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium text-gray-800">{title}</div>
          {subInfo && <div className="text-xs text-gray-500 mt-1">{subInfo}</div>}
          <div className="text-xs text-gray-400 mt-1">検索クエリ: {query}</div>
        </div>
      </div>
    </div>
  )
}
